export class AuditPackageGenerateRiskItem {
  auditPackageItemId: number;
  auditPackageId: number;
  chaseId: number;
  projectId: number;
  measureCode: string;
  numeratorCode: string;
  pageRanges: string;
  auditReadyUserId: number | null;
  chaseComplianceCode: string;
  icdCode: string;
  hccs: string;
  vrc: string;
  userRank: number | null;

  constructor(options: Partial<AuditPackageGenerateRiskItem>) {
    this.auditPackageItemId = options.auditPackageItemId;
    this.auditPackageId = options.auditPackageId;
    this.chaseId = options.chaseId;
    this.projectId = options.projectId;
    this.measureCode = options.measureCode;
    this.numeratorCode = options.numeratorCode;
    this.pageRanges = options.pageRanges;
    this.auditReadyUserId = options.auditReadyUserId;
    this.chaseComplianceCode = options.chaseComplianceCode;
    this.icdCode = options.icdCode;
    this.hccs = options.hccs;
    this.vrc = options.vrc;
    this.userRank = options.userRank;
  }
}
